import rest from "../script/rest";

class CalculationRest {

    async overview(entryId) {
        const url = "/rest/calculation/overview"
            + "?entryId=" + entryId;
        const response = await rest.get(url);
        return response.json();
    }

    async overviewWorstcase(entryId) {
        const url = "/rest/calculation/overviewWorstcase"
            + "?entryId=" + entryId;
        const response = await rest.get(url);
        return response.json();
    }

    async wattwaechter(entryId, calcAreaIds) {
        const url = "/rest/calculation/wattwaechter"
            + "?entryId=" + entryId
            + "&calcAreaIds=" + calcAreaIds.join(",");
        const response = await rest.get(url);
        return response.json();
    }

    async worstcase(entryId, calcAreaIds, worstcaseFarField) {
        const url = "/rest/calculation/worstcase"
            + "?entryId=" + entryId
            + "&calcAreaIds=" + calcAreaIds.join(",")
            + "&worstcaseFarField=" + worstcaseFarField;
        const response = await rest.get(url);
        return response.json();
    }

    async ixus(entryId) {
        const url = "/rest/calculation/ixus"
            + "?entryId=" + entryId;
        const response = await rest.get(url);
        return response.json();
    }

    async worstcaseData(antennaId, worstcaseDataFarField) {
        const url = "/rest/calculation/worstcaseData"
            + "?antennaId=" + antennaId
            + "&worstcaseDataFarField=" + worstcaseDataFarField;
        await rest.get(url);
    }

    async worstcasePoint(entryId, calcAreaId, ratioU, ratioV, slice) {
        const url = "/rest/calculation/worstcasePoint"
            + "?entryId=" + entryId
            + "&calcAreaId=" + calcAreaId
            + "&ratioU=" + ratioU
            + "&ratioV=" + ratioV
            + "&slice=" + slice;
        const response = await rest.get(url);
        return response.json();
    }

    async wattwaechterPoint(entryId, calcAreaId, ratioU, ratioV, slice) {
        const url = "/rest/calculation/wattwaechterPoint"
            + "?entryId=" + entryId
            + "&calcAreaId=" + calcAreaId
            + "&ratioU=" + ratioU
            + "&ratioV=" + ratioV
            + "&slice=" + slice;
        const response = await rest.get(url);
        return response.json();
    }

    async cancelEntry(entryId) {
        const url = "/rest/calculation/cancelEntry"
            + "?entryId=" + entryId;
        const response = await rest.get(url);
        return response.json();
    }

    async cancelAntenna(anntennaId) {
        const url = "/rest/calculation/cancelAntenna"
            + "?antennaId=" + anntennaId;
        await rest.get(url);
    }
}
const calculationRest = new CalculationRest();
window.calculationRest = calculationRest;
export default calculationRest;